const errorMap = {
    'com.bmo.input_too_big': 'Input too big.',
};

const callSpecificErrorMap = {
    'stock.searchKeyword_com.bmo.input_too_big': 'Too many results. Refine your search.',
};



export const getErrorMessage = (errorCode = "", callName = "") => {
    const token = `${callName}_${errorCode}`;
    return callSpecificErrorMap[token] || errorMap[errorCode] || errorCode;
}

